function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
const autoPlay = {
    type: FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Carousel auto play",
    conditionalKeyName: "enable",
    options: [
        {
            text: "True",
            fieldsConfig: {
                autoplaySpeed: {
                    type: FIELD_TYPES.TEXT,
                    label: "Auto play speed"
                },
                speed: {
                    type: FIELD_TYPES.TEXT,
                    label: "Transition speed"
                }
            }
        }
    ]
};
const cardConfig = {
    type: FIELD_TYPES.NESTED,
    label: "Card config",
    fields: {
        cardDetailsPadding: {
            type: FIELD_TYPES.TEXT,
            label: "Card Details Padding"
        },
        spaceBetweenCardDetails: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Space Between Card Details to Maximum"
        },
        useCaseColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Use Case Color"
        }
    }
};
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, SharedAdvancedFieldsConfig), {
        autoPlay,
        cardConfig
    })
};
